import { render, staticRenderFns } from "./CustomProperty.vue?vue&type=template&id=4f8431d4&"
import script from "./CustomProperty.vue?vue&type=script&lang=ts&"
export * from "./CustomProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports